import { render, staticRenderFns } from "./dropdown_header.vue?vue&type=template&id=0c09425a"
import script from "./dropdown_header.vue?vue&type=script&lang=js"
export * from "./dropdown_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports